var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-wrapper"},[_c('b-row',{staticClass:"main-content"},[_c('img',{attrs:{"src":require('@/assets/image/github.png')}}),_c('b-button',{on:{"click":_vm.gotoAuth}},[_vm._v(" Sign in with Github ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }